import * as React from 'react';
import Base from './base';
import Date from './date';
import SingleChoicelist from './singleChoiceList';
import InlineEditableField from '../../InlineEditableField';
import Icon from '../../../icons';
import { DATE_FORMAT, SHOW_PROPERTY_TIMEZONE_DATE_FIELD } from "../../../containers/WorkkardDetail/constants";
var moment = require('moment-timezone');
import { fetchDateFormatByTimezone, fetchTimezoneAbbreviation, checkAndShowDateFieldValueAccToWorkkardTz } from "../../../common/util";
import { DEFAULT_TIME_FORMAT, DEFAULT_DATE_FORMAT } from '../../../common/constants';

const hasFieldValue = (field) =>
    field.HasValue ?? (field.Value !== null && field.Value !== undefined && String(field.Value).trim() !== "");

const readSetting = (setting) =>
    setting !== null && typeof setting === 'object' ? setting.default : setting;
const isSettingEnabled = (setting) => {
    const value = readSetting(setting);
    return value === true || value === 'true';
};
const settingIncludes = (setting, text) => String(readSetting(setting) ?? '').includes(text);

class DatetimeTimezone extends Base {
    constructor(props) {
        super(props);
        this.groupName = "DateTimeTimezone";
        this.timezoneIdentifier = "timezone";
        this.datetimeIdentifier = "datetime";
        this.state = {
            dateTimeWM: "DateTime",
            timeZoneWM: "TimeZone",
            showTimezone: false
        }
    }
    changePlaceholder = (value) => {
        // this.setState({
        //     dateTimeWM:this.watermark[value].datetime,
        //     timeZoneWM:this.watermark[value].timezone
        // })
    }

    removeErrorOnFocus = (e) => {
        if (!$('#' + e.target.name + 'errorBlock').is(':empty')) {
            $('#' + e.target.name + 'errorBlock').text('')
        }
    }

    displayDateField = (field, workkardTz, userTimezone, fieldTimeFormat, listOfTimeZone, renderType) => {
        let UserTzDateFielValue = fetchDateFormatByTimezone(field.Value, workkardTz, userTimezone).format(fieldTimeFormat);
        let dateFieldsLabel=SHOW_PROPERTY_TIMEZONE_DATE_FIELD.map(item=>item.toLowerCase());
        let workkardTzDateFieldValue = renderType.toLowerCase() === 'activity' ? checkAndShowDateFieldValueAccToWorkkardTz(field.Value, dateFieldsLabel, field.FieldGroup.toLowerCase(), userTimezone, workkardTz, listOfTimeZone, fieldTimeFormat) : '';
        if (workkardTzDateFieldValue != '') {
            let combinedValue = `${UserTzDateFielValue} ${workkardTzDateFieldValue}`;
            return combinedValue;
        }
        return UserTzDateFielValue;

    }

    renderOnCard() {
        let { renderType, data, showLabel = false, userTimezone, tzData } = this.props;
        let dataValue = "";
        if (Array.isArray(data) && renderType.toLowerCase() === 'workkard') {
            if (data.length == 1) {
                dataValue = data[0].Value !== "" ? moment(data[0].Value).isValid() ? moment.utc(data[0].Value).format(DATE_FORMAT) : "-" : data[0].Value
            }
            else {
                for (let i = 0; i < data.length; i++) {
                    const fieldSetting = data[i].FieldSettings ? JSON.parse(data[i].FieldSettings) : {};
                    let timeOrTimezoneValue = "";
                    if (data[i].FieldType == "datetime") {
                        if (!hasFieldValue(data[i])) {
                            dataValue = '-';
                            break;
                        } else {
                            const fieldTimeFormat = isSettingEnabled(fieldSetting.output_time_component) ? DEFAULT_TIME_FORMAT : DEFAULT_DATE_FORMAT;
                            const customFieldTimezoneDisTxt = data.filter(x => x.FieldType.includes("timezone"))[0].Value;
                            const customFieldTimezoneId = customFieldTimezoneDisTxt != "" && tzData?.find(item => item.mapped_time_zone === customFieldTimezoneDisTxt || item.display_value === customFieldTimezoneDisTxt || item.standard_time_zone === customFieldTimezoneDisTxt)?.standard_time_zone;
                            timeOrTimezoneValue = data[i].Value !== "" ? moment(data[i].Value).isValid() && Object.keys(fieldSetting).length > 0 ?
                                settingIncludes(fieldSetting.output_to_timezone, "user") && userTimezone !== undefined ?
                                    fetchDateFormatByTimezone(data[i].Value, customFieldTimezoneId, userTimezone).format(fieldTimeFormat)
                                    : moment.utc(data[i].Value).format(fieldTimeFormat)
                                : data[i].Value : "-";
                        }
                    } else if (data[i].FieldType == "timezone") {
                        timeOrTimezoneValue = data[i].Value != "" ? (Object.keys(fieldSetting).length == 0 ? data[i].Value : fieldSetting.output_timezone_component ? fetchTimezoneAbbreviation(data[i].Value, tzData) : "") : "";
                    }
                    dataValue = dataValue + " " + timeOrTimezoneValue;
                    // dataValue=dataValue +" "+(data[i].Value !== "" ? moment(data[i].Value).isValid() ? moment.utc(data[i].Value).format(DATE_FORMAT) : data[i].Value : "-");
                }
            }
            data = data[0];
        }
        if (renderType.toLowerCase() === 'workkard') {
            return (showLabel) ?
                (<li data-test={data.Label}><label>{data.Label || data.FieldGroup} </label> : <span>{dataValue}</span></li>)
                :
                (<li data-test={dataValue}>{dataValue}</li>)
        }
        else {
            return null;
        }
    }
    renderOnGrid() {
        return null;
    }
    renderOnDetail() {
        let { renderType, data, showLabel = false, userTimezone, tzData } = this.props;
        let dataValue = "";
        if (Array.isArray(data)) {
            if (data.length == 1) {
                dataValue = data[0].Value !== "" ? moment(data[0].Value).isValid() ? moment.utc(data[0].Value).format(DATE_FORMAT) : "-" : data[0].Value
            }
            else {
                for (let i = 0; i < data.length; i++) {
                    const fieldSetting = data[i].FieldSettings ? JSON.parse(data[i].FieldSettings) : {};
                    let timeOrTimezoneValue = "";
                    if (data[i].FieldType == "datetime") {
                        if (!hasFieldValue(data[i])) {
                            dataValue = '-';
                            break;
                        } else {

                            const fieldTimeFormat = isSettingEnabled(fieldSetting.output_time_component) ? DEFAULT_TIME_FORMAT : DEFAULT_DATE_FORMAT;
                            const customFieldTimezoneDisTxt = data.filter(x => x.FieldType.includes("timezone"))[0].Value;
                            const customFieldTimezoneId = customFieldTimezoneDisTxt != "" && tzData?.find(item => item.mapped_time_zone === customFieldTimezoneDisTxt || item.display_value === customFieldTimezoneDisTxt || item.standard_time_zone === customFieldTimezoneDisTxt)?.standard_time_zone;
                            timeOrTimezoneValue = data[i].Value !== "" ? moment(data[i].Value).isValid() ?
                                settingIncludes(fieldSetting.output_to_timezone, "user") && userTimezone !== undefined ?
                                    this.displayDateField(data[i], customFieldTimezoneId, userTimezone, fieldTimeFormat, tzData, renderType)
                                    : moment.utc(data[i].Value).format(fieldTimeFormat)
                                : data[i].Value : "-";
                        }
                    } else if (data[i].FieldType == "timezone") {
                        timeOrTimezoneValue = fieldSetting.output_timezone_component ? fetchTimezoneAbbreviation(data[i].Value, tzData) : "";
                    }
                    dataValue = dataValue + " " + timeOrTimezoneValue;
                    // dataValue=dataValue +" "+(data[i].Value !== "" ? moment(data[i].Value).isValid() ? moment.utc(data[i].Value).format(DATE_FORMAT) : data[i].Value : "-");
                }
            }
            data = data[0];
        }

        if (renderType.toLowerCase() === 'activity') {
            return (showLabel) ?
                (<li data-test={data.Label}><label>{data.Label}: </label>
                    <InlineEditableField
                            type="datetimetimezone"
                            data={data}
                            Options={this.props.tzData}
                            userTimezone={this.props.userTimezone} 
                            fieldValue={dataValue}
                            combinedData={this.props.data}
                            canEdit={this.props.canEditActivity}
                            isCompositeField={true}
                            removeErrorOnFocus={(e) =>this.removeErrorOnFocus(e)}
                            updateField={(data) => this.props.updateActivityField(data)} />
                    
                  </li>)
                :
                (<li data-test={dataValue}>{dataValue}</li>)
        } else if (renderType.toLowerCase() === 'workkard') {
            return (showLabel) ?
                (<li data-field-label={this.props.isShowDetailOnPopUp ? data.FieldKey+"label_block" : data.FieldKey} data-test={data.Label}><label>{data.Label} </label>
                    {(this.props.dragndrop || !this.props.isShowDetailOnPopUp) 
                        ? (<span>{dataValue}</span>)  
                        : <InlineEditableField
                            type="datetimetimezone"
                            data={data}
                            Options={this.props.tzData}
                            userTimezone={this.props.userTimezone} 
                            fieldValue={dataValue}
                            combinedData={this.props.data}
                            timezoneAsCaption={true}
                            canEdit={this.props.canEditWorkkard}
                            isCompositeField={true}
                            removeErrorOnFocus={(e) =>this.removeErrorOnFocus(e)}
                            updateField={(data) => this.props.updateWorkkardFieldInfo(data)} />
                    }   
                </li>)
                :
                (dataValue)
        }
        else if (renderType.toLowerCase() === 'activitylisting') {
            if(showLabel){
             return (
                <label className="requestOn">
                    <span data-test={data.Label}>
                    {data.Label}:
                    </span>
                    <span data-test={data.Value} className={dataValue=="-"?"requestOnBlank;":"black"}>{dataValue=="-"?" NA":dataValue}</span>
                </label>
                
                )
            } 
        }else {
            return (showLabel) ?
                (<React.Fragment><label>{data.Label}: </label>{dataValue}</React.Fragment>)
                :
                (dataValue)
        }
    }

    renderOnCreate() {
        const timezone = "";
        const data = this.props.data.map(item => {
            const fieldSetting = item.FieldSettings ? JSON.parse(item.FieldSettings) : {};
            if (item.FieldType = "timezone") {
                let data = Object.assign({}, item, { Options: this.props.tzData, Label: "" });
                if (this.props.timeZoneValue.trim("") != "") {
                    data = Object.assign({}, item, { Options: this.props.tzData, Value: item.Value ? item.Value : fieldSetting.timezone_from.includes('user') ? (this.props.userTimeZoneValue ? this.props.userTimeZoneValue : this.props.timeZoneValue) : this.props.timeZoneValue });
                    timezone = item.Value ? item.Value : fieldSetting.timezone_from.includes('user') ? (this.props.userTimeZoneValue ? this.props.userTimeZoneValue : this.props.timeZoneValue) : this.props.timeZoneValue;
                }
                // if(fieldSetting.input_timezone_component){
                //     this.setState({
                //         showTimezone:true
                //     })
                // }
                return data;
            }
            return Object.assign({}, item, { Label: "" });
        });
        const props = Object.assign({}, this.props, { timeZoneValue: timezone.trim("") != "" ? timezone : this.props.timeZoneValue })
        return (
            <div className="formGroup row-fluid">
                <label className="wth-3">{data[0].FieldGroup}{data[0].IsRequired && <sup>*</sup>}
                    <span className="quickTooltip-bottom" data-quicktooltip={data.Description}><Icon name="info" className="icon ml greyInfoIcon" /></span>
                </label>

                <div className="colFlex">
                    <div className="rowFlex formRow">
                        <div className="wth-6 bottomSpace">
                            <Date {...this.props} showLabel={false} returnValueForBlank={""}
                                data={this.parseCustomFileds(data, this.datetimeIdentifier, this.groupName)}
                            />
                        </div>
                        <div className="wth-6 bottomSpace">
                            <SingleChoicelist {...props} showLabel={false} returnValueForBlank={""} preAppendComma={true} includeSpace={true}
                                data={this.parseCustomFileds(data, this.timezoneIdentifier, this.groupName)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DatetimeTimezone;